import { useLazyQuery } from '@apollo/client';

import { fetchRolesQuery } from '@queries/fetchRolesQuery';

import { GetRolesQuery, GetRolesQueryVariables } from '@typings/operations';

export const useFetchRoles = () =>
  useLazyQuery<GetRolesQuery, GetRolesQueryVariables>(fetchRolesQuery);
